import React, { FC, useContext } from 'react'
import useSWR from 'swr'
import { datadogRum } from '@datadog/browser-rum'

import { fetchProfile } from 'services/api/core/profile'

const AuthContext = React.createContext<Profile | undefined>(undefined)

const AuthProvider: FC = props => {
  const { data: profile } = useSWR<Profile>('core::/profile', fetchProfile)
  const { id, email, fullName: name } = profile ?? {}

  datadogRum.setUser({ id, email, name })

  return <AuthContext.Provider value={profile} {...props} />
}

function useAuth() {
  const auth = useContext(AuthContext)
  if (!auth) {
    throw new Error('Cannot use `useAuth` outside of AuthProvider')
  }

  return auth
}

export { AuthProvider, useAuth }
